import source from '../assets/source.json';
import { getById } from './poemService';

function constructPoems(poemIdArray) {
    const poems = poemIdArray.map(id => getById(id.toString()));
    return poems
}

const skittle = [50, 49, 65, 26, 66, 47];
const inlove = [20, 41, 35, 58, 61, 65, 5, 59, 22, 46, 57, 32];
const meadows = [60, 10, 2, 19, 12, 56, 44, 30, 8, 24, 50];
const political = [72, 74, 42, 18, 21, 27];
const holyrood = [55, 9, 51, 21, 67, 47, 66, 26, 65];
const princes = [43, 61, 29, 12, 57, 41];
const cowgate = [7, 3, 46, 11, 12, 39, 70, 18, 13, 40, 31, 20, 16, 14];
const ladies = [68, 2, 19, 33, 53, 42];
const edinburgh = [53, 8, 67, 63];
const volunteer = [2, 69, 35, 45, 46, 58];
const social = [43, 42, 68, 36];
const belonging = [37, 61, 54, 70, 50, 49];

export function getCuratedTour(name) {
    switch (name) {
        case 'skittle':
            return constructPoems(skittle);
        case 'inlove':
            return constructPoems(inlove);
        case 'meadows':
            return constructPoems(meadows);
        case 'political':
            return constructPoems(political);
        case 'holyrood':
            return constructPoems(holyrood);
        case 'princes':
            return constructPoems(princes);
        case 'cowgate':
            return constructPoems(cowgate);
        case 'ladies':
            return constructPoems(ladies);
        case 'edinburgh':
            return constructPoems(edinburgh);
        case 'volunteer':
            return constructPoems(volunteer);
        case 'social':
            return constructPoems(social);
        case 'belonging':
            return constructPoems(belonging);
        default:
            return null;
    }
}
